import { useParams } from 'react-router-dom';
import InsightsListBaseToolbar from 'src/pages/Insights/components/InsightsListToolbar/InsightsListBaseToolbar';
import InsightsRefreshDataButton from 'src/pages/Insights/components/InsightsListToolbar/InsightsRefreshDataButton';
import { InsightsFilterTimePeriodMenu } from 'src/pages/Insights/components/InsightsFilter/InsightsFilterTimePeriodMenu';
import { InsightsFilterMetricMenu } from 'src/pages/Insights/components/InsightsFilter/InsightsFilterMetricMenu';
import { InsightsFilterDisplayMenu } from 'src/pages/Insights/components/InsightsFilter/InsightsFilterDisplayMenu';
import { InsightsViewRadioGroup } from 'src/pages/Insights/components/InsightsViewRadioGroup';
import { useInsightsLastSyncedTime } from 'src/pages/Insights/util/useInsightsJob';
import { useInsightsAdAccount } from 'src/pages/Insights/util/useInsightsQueries';
import { useInsightsLayout } from 'src/pages/Insights/util/useInsightsPersistentState';
import { InsightsAnalysisSettings } from './InsightsAnalysisSettings';

export const InsightsAnalysisToolbar = () => {
  const { accountUuid } = useParams();
  const layout = useInsightsLayout();
  const { adAccount, accountCustomConversions, accountCustomEvents } =
    useInsightsAdAccount({
      accountUuid,
    });

  const subtitle = useInsightsLastSyncedTime();

  return (
    <InsightsListBaseToolbar
      icon={null}
      title={adAccount.data?.name}
      subtitle={subtitle}
      className={layout === 'grid' ? 'sticky top-[72px]' : undefined}
      actions={
        <div className="flex flex-row items-center gap-3 overflow-auto pb-3">
          <InsightsRefreshDataButton />
          <InsightsAnalysisSettings />
          <InsightsFilterTimePeriodMenu data-intercom-target="insight_date" />
          <InsightsFilterMetricMenu
            customEvents={accountCustomEvents ?? null}
            customConversions={accountCustomConversions ?? null}
          />
          <InsightsFilterDisplayMenu
            customEvents={accountCustomEvents ?? null}
            customConversions={accountCustomConversions ?? null}
          />
          <InsightsViewRadioGroup />
        </div>
      }
    />
  );
};
